import React from 'react'

const About = () => {
  return (
    <div id="about" name="about" className='w-full h-full bg-gradient-to-b from-gray-800  to-black
    text-white'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-500'>
                 About  
                </p>
            </div>
            <p className='text-xl mt-15'>
            Welcome folks ! I'm Shikhar Dave, a passionate Machine Learning Enthusiast and a student at the Indian Institute of Technology, Jodhpur.
           With a strong foundation in DL and a keen interest in cutting-edge technologies, I strive to make a positive impact in the field of artificial intelligence and machine learning. 
           Throughout my academic journey, I have consistently excelled in various subjects, including data structures and algorithms, machine learning, and deep learning.
            These skills have enabled me to tackle complex challenges and develop innovative solutions. 
            I have been fortunate to work on diverse projects that span different domains, showcasing my ability to adapt and apply my knowledge effectively.
       In addition to my academic pursuits, I have been actively involved in various extracurricular activities and leadership roles. As the Internship Coordinator at the Career Development Cell at IITJ, I am overseeing student internships, placements, and maintaining the official website. Dedicated to facilitating student career advancement.
       

If you share similar passions or have exciting opportunities to explore, feel free to reach out. Let's connect and embark on a journey to drive positive change through technology!
 <br/>
Best regards.

            </p>
        </div>
    </div>
  )
}

export default About
